import { useState } from 'react';
import { ArrowsPointingOutIcon } from '@heroicons/react/24/outline';

import MediaPreviewModal from '../../../common/MediaPreviewModal';

interface CanvasPreviewImageProps {
  src: string;
  alt: string;
  className?: string;
  imageClassName?: string;
}

export default function CanvasPreviewImage({
  src,
  alt,
  className = '',
  imageClassName = '',
}: CanvasPreviewImageProps) {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`clip-canvas-preview-image nodrag nopan nowheel ${className}`}
        onClick={(event) => {
          event.stopPropagation();
          setPreviewOpen(true);
        }}
        aria-label={`预览${alt}`}
        title={`预览${alt}`}
      >
        <img src={src} alt={alt} className={imageClassName} />
        <span className="clip-canvas-preview-image__overlay" aria-hidden="true">
          <ArrowsPointingOutIcon className="clip-canvas-preview-image__icon" />
        </span>
      </button>
      <MediaPreviewModal
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
        type="image"
        src={src}
        alt={alt}
      />
    </>
  );
}
